/**
 * Centralized route constants for the application.
 * This helps maintain consistency and prevents typos in route strings.
 * @readonly
 * @enum {string}
 */
export const Routes = Object.freeze({
  // Daily Play's home, and the route the app lands on for a learner the
  // `dailyPlay` flag is on for. The game view is nested under it on purpose:
  // BottomTabBar decides which tab is lit with a prefix match on the path, so
  // a round in progress keeps Today lit. The landing decision itself lives in
  // src/scripts/landingRoute.js.
  DASHBOARD_TODAY: "/dashboard/today",
  DASHBOARD_TODAY_PLAY: "/dashboard/today/play",
  DASHBOARD_COURSE: "/dashboard/course",
  DASHBOARD_CHAT: "/dashboard/chat",
  DASHBOARD_PROGRESS: "/dashboard/progress",
  DASHBOARD_ACCOUNT: "/dashboard/account",
  ONBOARDING: "/onboarding",
  BLOG: "/blog",
  FAQ: "/faq",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_OF_SERVICE: "/terms-of-service",
});

/**
 * Fragment identifier of the Account page's upgrade-options section.
 *
 * Shared so the two sides cannot drift: AccountView renders the id, and any
 * surface that wants to drop the reader straight into the plans (the free-tier
 * usage pill) navigates with this hash. AccountView resolves its plan
 * asynchronously, so the section does not exist when the router's
 * scrollBehavior runs; AccountView scrolls to it itself once the plan lands.
 * @type {string}
 */
export const ACCOUNT_UPGRADE_HASH = "#upgrade-options";

/**
 * Helper function to get dashboard base path
 * @returns {string}
 */
export const getDashboardBasePath = () => "/dashboard";
